import { ErrorHandler, NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { BrowserModule } from '@angular/platform-browser';
import { CallNumber } from '@ionic-native/call-number';
import { Device } from '@ionic-native/device';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { InAppPurchase } from '@ionic-native/in-app-purchase';
import { LaunchNavigator } from '@ionic-native/launch-navigator';
import { SplashScreen } from '@ionic-native/splash-screen';
import { StatusBar } from '@ionic-native/status-bar';
import { IonicStorageModule } from '@ionic/storage';
import { IonicApp, IonicErrorHandler, IonicModule, Keyboard, Platform } from 'ionic-angular';
import { IonAlphaScrollModule } from 'ionic2-alpha-scroll';
import { ContentBlockComponent } from '../components/content-block/content-block';
import { GoogleMap } from '../components/google-map';
import { NoConnectionComponent } from '../components/no-connection/no-connection';
import { BookmarkPage } from '../pages/bookmark/bookmark';
import { BookmarksPage } from '../pages/bookmarks/bookmarks';
import { BrowseCategoryPage } from '../pages/browse-category/browse-category';
import { BrowseDirectoryPage } from '../pages/browse-directory/browse-directory';
import { CategoryResultsPage } from '../pages/category-results/category-results';
import { CategorySectionSinglePage } from '../pages/category-section-single/category-section-single';
import { CategorySectionPage } from '../pages/category-section/category-section';
import { CategorySinglePage } from '../pages/category-single/category-single';
import { ChangePasswordPage } from '../pages/change-password/change-password';
import { ContactUsPage } from '../pages/contact-us/contact-us';
import { ForgotPasswordConfirmationPage } from '../pages/forgot-pasword-confirmation/forgot-pasword-confirmation';
import { ForgotPasswordPage } from '../pages/forgot-pasword/forgot-password';
import { HomePage } from '../pages/home/home';
import { IntroductionPage } from '../pages/introduction/introduction';
import { LoginPage } from '../pages/login/login';
import { MyAccountPage } from '../pages/my-account/my-account';
import { PurchaseHardcopyModule } from '../pages/purchase-hardcopy/module';
import { RegisterConfirmationPage } from '../pages/register-confirmation/register-confirmation';
import { RegisterPage } from '../pages/register/register';
import { SamplePage } from '../pages/sample/sample';
import { SearchDirectoryPage } from '../pages/search-directory/search-directory';
import { SubscriptionsPage } from '../pages/subscriptions/subscriptions';
import { LicencePromptPage } from '../pages/desktop/licence-prompt/licence-prompt';
import { LicenceOkPage } from '../pages/desktop/licence-ok/licence-ok';
import { EntryPage } from '../pages/desktop/entry/entry';
import { ContactPage } from '../pages/desktop/contact/contact';
import { SplitViewPage } from "../pages/desktop/split-view/split-view";

import { Api } from '../providers/api';
import { BookmarkService } from '../providers/bookmark-service';
import { GoogleMapsService } from '../providers/google-maps';
import { RecentSearchService } from '../providers/recent-search-service';
import { SubscriptionService } from '../providers/subscription-service';
import { UserService } from '../providers/user-service';
import { MyApp } from './app.component';
import { DirectoryService } from '../providers/directory-service';
import { InAppPurchaseMock } from '../providers/mocks/in-app-purchase';
import { TermsAndConditionsPage } from '../pages/terms-and-conditions/terms-and-conditions';
import { PrivacyPolicyPage } from '../pages/privacy-policy/privacy-policy';
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics';
import { DesktopService } from "../providers/desktop-service";
import { FirebaseAnalyticsMock } from "../providers/mocks/FirebaseAnalyticsMock";
import { BlankDesktopPage } from "../pages/desktop/blank/blank";
import { NetworkService } from "../providers/network-service";
import { DesktopHeaderComponent } from '../components/desktop-header/desktop-header';
import { DesktopOnlyDirective } from '../directives/desktop-only';
import { MobileOnlyDirective } from '../directives/mobile-only';
import { AdvertBannerComponent } from "../components/advert-banner/advert-banner";

export function createInAppPurchase(platform: Platform): InAppPurchase {
    if (typeof (<any> window).cordova == 'undefined') {
        return new InAppPurchaseMock(platform);
    } else {
        return new InAppPurchase();
    }
}

export function createFirebaseAnalytics() {
    let instanceClass = typeof(<any> window).cordova !== 'undefined' ? FirebaseAnalytics : FirebaseAnalyticsMock;
    return new instanceClass();
}

@NgModule({
  declarations: [
    MyApp,
    HomePage,
    SamplePage,
    IntroductionPage,
    RegisterPage,
    RegisterConfirmationPage,
    LoginPage,
    ForgotPasswordPage,
    ForgotPasswordConfirmationPage,
    ChangePasswordPage,
    BrowseDirectoryPage,
    BrowseCategoryPage,
    CategoryResultsPage,
    CategorySinglePage,
    CategorySectionPage,
    CategorySectionSinglePage,
    MyAccountPage,
    SearchDirectoryPage,
    ContactUsPage,
    SubscriptionsPage,
    BookmarksPage,
    BookmarkPage,
    LicencePromptPage,
    LicenceOkPage,
    ContactPage,
    EntryPage,
    SplitViewPage,
    BlankDesktopPage,
    GoogleMap,
    TermsAndConditionsPage,
    PrivacyPolicyPage,
    ContentBlockComponent,
    AdvertBannerComponent,
    NoConnectionComponent,
    DesktopHeaderComponent,
    DesktopOnlyDirective,
    MobileOnlyDirective,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    IonAlphaScrollModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot(),
    PurchaseHardcopyModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    SamplePage,
    IntroductionPage,
    RegisterPage,
    RegisterConfirmationPage,
    LoginPage,
    ForgotPasswordPage,
    ForgotPasswordConfirmationPage,
    ChangePasswordPage,
    BrowseDirectoryPage,
    BrowseCategoryPage,
    CategoryResultsPage,
    CategorySinglePage,
    CategorySectionPage,
    CategorySectionSinglePage,
    MyAccountPage,
    SearchDirectoryPage,
    ContactUsPage,
    SubscriptionsPage,
    BookmarksPage,
    BookmarkPage,
    LicencePromptPage,
    LicenceOkPage,
    SplitViewPage,
    BlankDesktopPage,
    TermsAndConditionsPage,
    EntryPage,
    ContactPage,
    PrivacyPolicyPage,
    GoogleMap
  ],
  providers: [
    Api,
    BookmarkService,
    CallNumber,
    Device,
    DirectoryService,
   { provide: FirebaseAnalytics, useFactory: createFirebaseAnalytics },
    GoogleMapsService,
    InAppBrowser,
    Keyboard,
    LaunchNavigator,
    RecentSearchService,
    StatusBar,
    SplashScreen,
    SubscriptionService,
    UserService,
    DesktopService,
    NetworkService,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    { provide: InAppPurchase, deps: [Platform], useFactory: createInAppPurchase },
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts